module.exports = {"Assembly":"Assembly","Cleaning & Finishing":"Cleaning & Finishing","Dimensional Inspection":"Dimensional Inspection","Engineering & Design":"Engineering & Design","Heat Treat":"Heat Treat","Liquid Penetrant":"Liquid Penetrant","Magnetic Particle":"Magnetic Particle","Painting":"Painting","Pattern Shop":"Pattern Shop","Radiography":"Radiography","Rough/Finish Machining":"Rough/Finish Machining","Surface Treatments":"Surface Treatments","Welding":"Welding"}


//////////////////
// WEBPACK FOOTER
// ./src/config/SecondaryOperations.json
// module id = 5419
// module chunks = 1